import { PopoverConfig } from 'ngx-bootstrap/popover';

export function getPopoverConfig(): PopoverConfig {
  return Object.assign(new PopoverConfig(), {placement: 'bottom', container: 'body', triggers: 'mouseenter:mouseleave'});
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/ciprs-popover-config.ts